'use client';

import { useState, useEffect, type ReactNode } from 'react';
import { useSearchParams } from 'next/navigation';
import dynamic from 'next/dynamic';

const NavigatorModal = dynamic(() => import('./NavigatorModal'), { ssr: false });
const CollectionsModal = dynamic(() => import('./CollectionsModal'), { ssr: false });

const MarketingModals = () => {
  const searchParams = useSearchParams();
  const [children, setChildren] = useState<ReactNode>(null);

  useEffect(() => {
    if (searchParams.has('collections_desktop')) {
      setChildren(<CollectionsModal isOpen onRequestClose={() => setChildren(null)} />);
    } else if (searchParams.has('navigator_desktop')) {
      setChildren(<NavigatorModal isOpen onRequestClose={() => setChildren(null)} />);
    } else {
      setChildren(null);
    }
  }, [searchParams]);

  return children;
};

export default MarketingModals;

